import { CSSProperties } from 'react';
import { AnnotateStudyHeaderComponent } from './annotate-study-header.component';
import { AnnotateStudyTabsComponent } from './annotate-study-tabs.component';

const containerStyle: CSSProperties = {
    height: '100%'
};
const bodyContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 2,
    height: 'calc(100% - 70px)',
    overflow: 'auto'
};

export const AnnotateStudyFormComponent = () => {
    return (
        <div style={containerStyle}>
            <div>
                <AnnotateStudyHeaderComponent />
            </div>
            <div style={bodyContainerStyle} className="scrolly">
                <AnnotateStudyTabsComponent />
            </div>
        </div>
    );
};
